import React from 'react';
import { style } from 'typestyle';
import { mediaDesktop } from '../utilities/mediaQueries';
import { spacing } from '../../../theme/spacing';
import { px } from 'csx';
import { centerCenter, flexRoot, vertical } from 'csstips';
import { rebrand } from '../../../theme/color';
import SimpleMasthead from '../molecules/mastheads/SimpleMasthead';
import { Container } from '../atoms/Container';

interface MusicLayoutProps {
  mastheadContent: React.ReactNode;
  mainContent: React.ReactNode;
  sidebarContent: React.ReactNode;
}

const styles = {
  wrapper: style(),
  masthead: style(
    {
      backgroundColor: rebrand.contrast[50].toHexString(),
    },
    mediaDesktop(vertical, centerCenter, {
      padding: `${spacing.XXLARGE} 0`,
      minHeight: px(172),
    })
  ),
  layout: style({}, mediaDesktop(flexRoot, {})),
  main: style(
    {
      padding: `${spacing.XLARGE} 0`,
    },
    mediaDesktop({
      order: 2,
      flex: 3,
      padding: `${spacing.XXLARGE} 0`,
    })
  ),
  sidebar: style(
    flexRoot,
    vertical,
    {
      backgroundColor: rebrand.neutralOnDark[10].toString(),
      padding: `${spacing.XLARGE} ${spacing.DEFAULT}`,
      gap: spacing.XLARGE,
    },
    mediaDesktop({
      order: 1,
      flex: 1,
      maxWidth: px(456),
      minWidth: px(379),
      padding: spacing.XLARGE,
    })
  ),
};

/** Layout component for artist, release and track pages */
export const MusicLayout: React.FC<MusicLayoutProps> = ({ mastheadContent, mainContent, sidebarContent }) => {
  return (
    <div className={styles.wrapper}>
      <SimpleMasthead className={styles.masthead}>
        <Container>{mastheadContent}</Container>
      </SimpleMasthead>

      <div className={styles.layout}>
        <section className={styles.main}>
          <Container>{mainContent}</Container>
        </section>

        <aside className={styles.sidebar}>{sidebarContent}</aside>
      </div>
    </div>
  );
};
